<template>
    <div ref="chartContainer" class="pie-chart-container"></div>
</template>

<script>
import * as echarts from 'echarts';

export default {
    props: {
        data: {
            type: Array,
            required: true,
            default: () => []
        }
    },
    watch: {
        data: {
            handler() {
                this.initChart();
            },
            deep: true // 深度监听数组变化
        }
    },
    data() {
        return {
            chart: null,
        };
    },
    beforeUnmount() {
        if (this.chart) {
            this.chart.dispose();
        }
    },
    methods: {
        initChart() {
            const container = this.$refs.chartContainer;
            if (!container) return;

            this.chart = echarts.init(container);

            const option = {
                color: ['#5470C6', '#91CC75', '#FAC858', '#EE6666', '#73C0DE', '#3BA272'], // 现代配色方案
                series: [{
                    type: 'pie',
                    center: ['50%', '50%'],
                    radius: ['45%', '60%'], // 调整内外半径比例以获得更好的视觉效果
                    label: {
                        show: true,
                        position: 'outside',
                        formatter(params) {
                            return `{name|${params.name}}\n{percent|${Math.round(params.percent)}%}`;
                        },
                        rich: {
                            name: {
                                fontSize: 12,
                                fontWeight: 'bold',
                                color: '#333'
                            },
                            percent: {
                                fontSize: 12,
                                color: '#666'
                            }
                        },
                        overflow: 'truncate',
                        width: 100,
                        lineHeight: 20
                    },
                    labelLine: {
                        show: true,
                        length: 15, // 引导线长度
                        length2: 20, // 第二段引导线长度
                        lineStyle: {
                            width: 1.5,
                            type: 'solid' // 固定线条样式
                        }
                    },
                    itemStyle: {
                        // 移除了圆角效果
                    },
                    data: this.data
                }]
            };

            this.chart.setOption(option);
        },
    }
};
</script>

<style scoped>
.pie-chart-container {
    width: 400px;
    height: 175px;
    margin: 0 auto;
}
</style>